import React, { useState } from "react";
import PropTypes from "prop-types";

import Modal from "components/Modal";
import Slick from "react-slick";

const Slider = ({ images }) => {
    const [showSlider, setShowSlider] = useState(false);

    return (
        <div className="slider-preview">
            <div className="slider-preview__title">
                <span className="fs-body2 c-gs-medium-em">Фото</span>
            </div>

            <div
                className="slider-preview__list"
                onClick={() => setShowSlider(true)}
            >
                <div className="slider-preview__item">
                    <img src={images[0].url} alt={images[0].name} />
                </div>
                {images.length > 1 && (
                    <div className="slider-preview__item">
                        <img src={images[1].url} alt={images[1].name} />
                        <div className="slider-preview__item-counter">
                            <span className="fs-body2 white">
                                +{images.length - 1}
                            </span>
                        </div>
                    </div>
                )}
            </div>

            {showSlider && (
                <Modal
                    onClose={() => setShowSlider(false)}
                    closeOnOverlay
                    modificators={["slider"]}
                >
                    <div className="modal-slider">
                        <Slick
                            infinite
                            dots={false}
                            speed={300}
                            slidesToShow={1}
                            slidesToScroll={1}
                            centerMode
                            centerPadding="200px"
                        >
                            {images.map((image, index) => {
                                return (
                                    <div key={index}>
                                        <img src={image.url} alt={image.name} />
                                    </div>
                                );
                            })}
                        </Slick>
                    </div>
                </Modal>
            )}
        </div>
    );
};

Slider.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({ url: PropTypes.string, name: PropTypes.string })
    ),
};

export default Slider;
